// extracted by mini-css-extract-plugin
module.exports = {"upsContainer":"UspExpandedCollection_upsContainer__P2qDW","uspExpandedCollectionTitle":"UspExpandedCollection_uspExpandedCollectionTitle___wPsD"};